module.exports = __webpack_public_path__ + "static/media/file-download.de312238.svg";